/**
 * description 融合编辑器-添加渠道弹窗
 * created by he.zhikai
 * created on 2017-12-28
 */
'use strict';
angular.module('editFusionAddNavsModule', [])
    .controller('editFusionAddNavsCtrl', ['$scope', '$filter', '$modalInstance', '$q', 'doctype', 'nowNavs', 'sourceDocId', 'trsHttpService', 'editFusionEditorService', 'modalDialog',
        function ($scope, $filter, $modalInstance, $q, doctype, nowNavs, sourceDocId, trsHttpService, editFusionEditorService, modalDialog) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.data = {
                    navs: [],
                    selectedNavs: []
                };
                $scope.status = {
                    doctype: doctype, // 稿件类型
                    sourceDocId: sourceDocId || ''
                };
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                initNavs().then(function () {
                    if (angular.isDefined(nowNavs)) {
                        for (var i = 0; i < $scope.data.navs.length; i++) {
                            for (var j = 0; j < nowNavs.length; j++) {
                                if ($scope.data.navs[i].MEDIATYPE == nowNavs[j].MEDIATYPE) {
                                    $scope.data.navs[i].hasSelected = true;
                                }
                            }
                        }
                        $scope.data.selectedNavs = nowNavs;
                    }
                });
            }

            /**
             * [initNavs description] 初始化可以关联的稿件
             * @return {[type]} [description]
             */
            function initNavs() {
                var defer = $q.defer();
                var params = {
                    serviceid: 'mlf_fusioncreate',
                    methodname: 'getMediaTypesByDocType',
                    doctype: $scope.status.doctype,
                    sourceDocId: $scope.status.sourceDocId
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    if ($scope.status.doctype === '2') {
                        data = $filter('removeWith')(data, { MEDIANAME: '微博' }); // 图集稿下去掉微博渠道，因为微博没有融合编辑器的载体
                    }
                    angular.forEach(data, function (value) {
                        value.routerName = editFusionEditorService.getRouterByMediatype(value.MEDIATYPE, $scope.status.doctype);
                    });
                    $scope.data.navs = data;
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [navIsSelected description] 复选框选中状态
             * @param  {[type]} nav [description] 当前渠道
             * @return {[type]}        [description]
             */
            $scope.navIsSelected = function (nav) {
                var index = getNavIndex(nav);
                return index != -1;
            };

            /**
             * [getNavIndex description] 获取当前渠道在所选渠道数组中的位置
             * @param  {[type]} nav [description] 当前渠道
             * @return {[type]}        [description]
             */
            function getNavIndex(nav) {
                for (var i = 0; i < $scope.data.selectedNavs.length; i++) {
                    if (nav.MEDIATYPE == $scope.data.selectedNavs[i].MEDIATYPE) {
                        return i;
                    }
                }
                return -1;
            }

            /**
             * [selectNav description] 选择复选框
             * @param  {[type]} nav [description]
             * @return {[type]}        [description]
             */
            $scope.selectNav = function (nav) {
                if (!nav.hasSelected) {
                    var index = getNavIndex(nav);
                    if (index == -1) {
                        $scope.data.selectedNavs.push(nav);
                    } else {
                        $scope.data.selectedNavs.splice(index, 1);
                    }
                }
            };

            /**
             * [cancel description] 取消
             * @return {[type]} [description]
             */
            $scope.cancel = function () {
                $modalInstance.dismiss();
            };

            /**
             * [confirm description] 确定
             * @return {[type]} [description]
             */
            $scope.confirm = function () {
                if ($scope.data.selectedNavs.length <= 1) {
                    modalDialog.alertType('请选择渠道', '', 'warning', false);
                    return;
                }
                $modalInstance.close($scope.data.selectedNavs);
            };

            /**
             * [showModule description] 是否显示渠道类别
             * @param  {[type]} mediaTypes [description] 渠道类别
             * @return {[type]}            [description]
             */
            $scope.showModule = function (mediaTypes) {
                var mediaTypesArray = mediaTypes.split(',');
                return $scope.data.navs.some(function (item, index) {
                    item.MEDIATYPE += '';
                    return mediaTypesArray.indexOf(item.MEDIATYPE) >= 0;
                });
            };
        }
    ]);
